import {
    ACCOUNT_INFO_REQUEST,
    ACCOUNT_INFO_SUCCESS,
    ACCOUNT_INFO_ERROR,
} from 'state/actions/account'

const initialState = {
    loaded: false,
    loading: false,
    errorMessage: '',
    id: null,
    role: undefined,
    periphery_id: null,
    periphery_name: null,
    permissions: {},
    available_features: [],
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case ACCOUNT_INFO_REQUEST:
        return {
            ...state,
            loading: true,
            errorMessage: '',
        }
    case ACCOUNT_INFO_SUCCESS:
        return {
            ...state,
            loaded: true,
            loading: false,
            id: action.payload.id,
            role: action.payload.role,
            periphery_id: action.payload.periphery_id,
            periphery_name: action.payload.periphery_name,
            permissions: action.payload.permissions,
            available_features: action.payload.available_features,
            elo_leaderboards: action.payload.elo_leaderboards,
        }
    case ACCOUNT_INFO_ERROR:
        return {
            ...state,
            loading: false,
            errorMessage: action.payload.errorMessage,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/account.js